<script lang="ts">import { Button } from "@infinitro/button";
import { Container } from "@infinitro/container";
import { t, Verbiage } from "@infinitro/content";
import { locale, ModalDialog, pushModal } from "@infinitro/global";
import { aboutVipBg, cardsDataFomo, steps } from "./data";
import Faqs from "./parts/faqs.svelte";
import VipRankRewardsAlternative from "./parts/vip-rank-rewards-alternative.svelte";
import VipTestimonials from "./parts/vip-testimonials.svelte";
import { getVerbiageKey } from "./utils";
</script>

<!-- markup (zero or more items) goes here -->

<div class="vip-header-wrapper">
	<div class="vip-header-bg-layer">
		<Container>
			<div class="vip-header-content">
				<h1 class="vip-header-title">{$t(Verbiage[getVerbiageKey('vip_title01')])}</h1>
				<h2 class="vip-header-subtitle">{$t(Verbiage[getVerbiageKey('vip_subtitle01')])}</h2>
				<hr class="vip-header-hr" />
			</div>
		</Container>

		<div class="steps-scroll-container">
			<div class="steps-list">
				{#each steps as item, i}
					<div class="step-card" class:min-h-210={$locale === 'en'}>
						<h2 class="step-card-title">
							{$t(Verbiage[item.title])}
						</h2>
						<span class="step-card-description">{$t(Verbiage[item.description])}</span>
					</div>
					{#if steps.length !== i + 1}
						<div class="step-connector">
							<div class="connector-dot dot-top"></div>
							<div class="connector-dot dot-bottom"></div>
						</div>
					{/if}
				{/each}
			</div>
		</div>

		<img class="vip-header-bg-image" src={aboutVipBg} alt={$t(Verbiage.vip_icons_alt, 'alts')} />
	</div>
</div>

<Container>
	<div class="welcome-section">
		<h2 class="subtitle02">
			{$t(Verbiage[getVerbiageKey('vip_subtitle02')])}
		</h2>
		<h1 class="welcome-section-title">{$t(Verbiage[getVerbiageKey('vip_title02')])}</h1>
		<hr />
		<span class="welcome-text">
			{@html $t(Verbiage[getVerbiageKey('vip_club_text')])}
		</span>
		<div class="welcome-actions">
			<span>
				{@html $t(Verbiage[getVerbiageKey('welcome_message')])}
			</span>
			<Button
				styleCustom="min-width: 140px"
				text={$t(Verbiage[getVerbiageKey('sign_up_text')])}
				onClick={() => pushModal(ModalDialog.Auth, { tab: 'signup' })}
			/>
		</div>
	</div>
</Container>

<Container>
	<div class="features-header">
		<h1 class="title">
			{$t(Verbiage[getVerbiageKey('vip_benefits_text')])}
		</h1>
	</div>
	<div class="features-section">
		<div class="features-scroll-container">
			<div class="features-list">
				{#each cardsDataFomo as item}
					<div class="feature-card">
						<div>
							<h2 class="feature-card-title">
								{$t(Verbiage[item.title])}
							</h2>
							<h3 class="feature-card-subtitle">
								{$t(Verbiage[item.subtitle]) !== '-' ? $t(Verbiage[item.subtitle]) : ''}
							</h3>
							<span class="feature-card-info">{@html $t(Verbiage[item.info])}</span>
						</div>
						<img src={item.image} alt={$t(Verbiage.vip_icons_alt, 'alts')} />
					</div>
				{/each}
			</div>
		</div>
	</div>
</Container>

<Container>
	<div class="rewards-header">
		<h1 class="title">
			{$t(Verbiage[getVerbiageKey('vip_rank_rewards')])}
		</h1>

		<div class="rewards-description">
			{@html $t(Verbiage[getVerbiageKey('like_what_you_see_text')])}
		</div>
	</div>
</Container>

<Container>
	<div class="vip-rank-rewards-container">
		<VipRankRewardsAlternative />
	</div>
</Container>

<Container>
	<VipTestimonials />
</Container>

<Container>
	<Faqs />
</Container>

<style>
	@import url('https://fonts.googleapis.com/css2?family=Holtwood+One+SC&display=swap');
	/* Provided Base Styles */
	.holtwood-font {
		font-family: 'Holtwood One SC', serif;
		font-weight: 400;
		font-style: normal;
	}
	.title{
		font-size: 28px;
		font-weight: 600;
		line-height: 28px;
		letter-spacing: 1px;
}
	.subtitle02{
		margin-bottom: 0.75rem;
		font-size: 0.875rem;
		line-height: 1.25rem;
}
	hr{
		height: 1px;
		border-radius: 1px;
		border-style: none;
		background-image: linear-gradient(to right, gray, #ffffff00);
}
	/* Section 1: Main Header */
	@media (min-width: 1536px){
		.vip-center{
				display: flex;
				justify-content: center;
		}
}
	.vip-header-wrapper{
		display: flex;
		justify-content: center;
}
	.vip-header-bg-layer{
		position: relative;
		overflow-y: hidden;
		--tw-bg-opacity: 1;
		background-color: rgb(21 20 64 / var(--tw-bg-opacity, 1));
		padding-top: 24px;
		padding-bottom: 60px;
		width: 100vw;
}
	@media (min-width: 1024px){
		.vip-header-bg-layer{
				width: calc(100vw - 240px);
				max-width: 1400px;
		}
}
	.vip-header-content{
		width: 100%;
		padding-left: 1rem;
		padding-right: 1rem;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
	.vip-header-title{
		margin-bottom: 0.5rem;
		font-size: 28px;
		font-weight: 600;
		line-height: 2rem;
		letter-spacing: 1px;
}
	@media (min-width: 1024px){
		.vip-header-title{
				font-size: 44px;
				line-height: 1.5;
		}
}
	.vip-header-subtitle{
		margin-bottom: 1rem;
		font-size: 0.75rem;
		line-height: 1rem;
		--tw-text-opacity: 1;
		color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
	@media (min-width: 1024px){
		.vip-header-subtitle{
				font-size: 20px;
		}
		.vip-header-hr{
				display: none;
		}
}
	.vip-header-bg-image{
		pointer-events: none;
		position: absolute;
		bottom: 0px;
		left: 0px;
}
	@media (min-width: 1024px){
		.vip-header-bg-image{
				left: calc(50% - 160px);
		}
}
	/* Section 1.1: Steps Scroller */
	.steps-scroll-container{
		position: relative;
		z-index: 10;
		margin-top: 30px;
		display: flex;
		overflow-x: auto;
		padding-left: 4vw;
		padding-right: 4vw;
}
	@media (min-width: 1024px){
		.steps-scroll-container{
				margin-top: 10px;
				justify-content: center;
		}
}
	.steps-scroll-container {
		scrollbar-width: none;
	}
	.steps-list{
		display: flex;
		align-items: center;
}
	.min-h-210{
		min-height: 210px !important;
}
	.step-card{
		min-height: 180px;
		width: 280px;
		border-radius: 0.75rem;
		--tw-bg-opacity: 1;
		background-color: rgb(76 114 250 / var(--tw-bg-opacity, 1));
		padding: 1rem;
		--tw-text-opacity: 1;
		color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
	.step-card-title{
		font-size: 28px;
		font-family: 'Holtwood One SC', serif;
		font-weight: 400;
		font-style: normal;
}
	.step-card-description{
		margin-top: 1rem;
		display: inline-block;
		font-size: 1.125rem;
		line-height: 1.75rem;
		font-weight: 500;
}
	.step-connector{
		position: relative;
		height: 50px;
		width: 12px;
		overflow: hidden;
		--tw-bg-opacity: 1;
		background-color: rgb(76 114 250 / var(--tw-bg-opacity, 1));
}
	.connector-dot{
		position: absolute;
		height: 12px;
		width: 12px;
		border-radius: 9999px;
		--tw-bg-opacity: 1;
		background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
	.dot-top{
		top: -6px;
}
	.dot-bottom{
		bottom: -6px;
}
	/* Section 2: Welcome Club */
	.welcome-section{
		margin-top: 3rem;
		width: 100%;
		padding-left: 1rem;
		padding-right: 1rem;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
	.welcome-section-title{
		margin-bottom: 2rem;
		font-size: 28px;
		font-weight: 600;
		line-height: 28px;
		letter-spacing: 1px;
}
	.welcome-text{
		margin-top: 1.25rem;
		display: inline-block;
}
	.text-highlight{
		color: var(--color-primary-500);
}
	.welcome-actions{
		margin-top: 1rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 1rem;
}
	@media (min-width: 1024px){
		.welcome-actions{
				flex-direction: row;
				justify-content: space-between;
		}
}
	/* Section 3: Features / Benefits */
	.features-section{
		position: relative;
		overflow: hidden;
}
	@media (min-width: 1536px){
		.features-section{
				display: flex;
				justify-content: center;
		}
}
	.features-header{
		margin-top: 3rem;
		width: 100%;
		padding-left: 1rem;
		padding-right: 1rem;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
	.features-scroll-container{
		position: relative;
		z-index: 10;
		margin-top: 40px;
		display: flex;
		overflow-x: auto;
		scrollbar-width: none;
}
	.features-list{
		width: 86vw;
}
	@media (min-width: 1024px){
		.features-list{
				width: calc(100vw - 240px - 8vw);
				max-width: 1400px;
		}
}
	.features-list{
		display: flex;
		gap: 1rem;
}
	.feature-card{
		display: flex;
		min-height: 180px;
		width: 260px;
		flex-direction: column;
		justify-content: space-between;
		border-radius: 0.75rem;
		background-color: var(--color-secondary-500);
		padding: 1rem;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
	.feature-card-title{
		font-size: 28px;
		line-height: 2rem;
		font-family: 'Holtwood One SC', serif;
		font-weight: 400;
		font-style: normal;
}
	.feature-card-subtitle{
		margin-top: 1rem;
		font-size: 20px;
}
	.feature-card-info{
		margin-top: 1rem;
		display: inline-block;
		font-size: 0.875rem;
		line-height: 1.25rem;
		--tw-text-opacity: 1;
		color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
	.rewards-header{
		margin-top: 3rem;
		width: 100%;
		padding-left: 1rem;
		padding-right: 1rem;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
	.rewards-description{
		margin-top: 1.25rem;
		display: inline-block;
}
	.vip-rank-rewards-container{
		width: 100%;
}
	@media (min-width: 1024px){
		.vip-rank-rewards-container{
				margin-top: -2rem;
				margin-left: -2rem;
		}
}
</style>
